/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_EmptyInputs */

const cs_deals_empty = /** @type {(inputs: Deals_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V pipeline zatím nejsou žádné obchody.`)
};

const en_deals_empty = /** @type {(inputs: Deals_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deals in the pipeline yet.`)
};

/**
* | output |
* | --- |
* | "No deals in the pipeline yet." |
*
* @param {Deals_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_empty = /** @type {((inputs?: Deals_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_empty(inputs)
	return cs_deals_empty(inputs)
});